import { Link } from 'react-router-dom'
import { EmptyBills } from 'components'
import { useFirebaseEvent } from 'hooks'
import './style.scss'

export function BillsCard({
  title = '',
  eventClick,
  tabId,
  isLoading = false,
  error,
  content = [],
  emptyMessage = '',
  isGrid = false,
  children,
  showTotal = false,
}) {
  const { sendEvent } = useFirebaseEvent()

  function handleClick() {
    sendEvent(eventClick)
  }

  function renderLoading() {
    return <div className='bills-card-loading' />
  }

  function renderEmpty() {
    return (
      <div className='empty-container'>
        <EmptyBills billType={emptyMessage} />
      </div>
    )
  }

  function renderContent() {
    if (isLoading) return renderLoading()

    const hasErrorOrEmpty = error || content?.length === 0
    if (hasErrorOrEmpty) return renderEmpty()

    return children
  }

  function renderTotal() {
    if (!showTotal) return null

    return content.length === 1 ? '(1 fatura)' : `(${content.length} faturas)`
  }

  return (
    <div className='bills-card-container'>
      <div className='header'>
        <h4 className='subtitle'>{title}</h4>
        <Link className='more' onClick={handleClick} to={`/minhas-faturas#${tabId}`}>
          Ver todas {renderTotal()}
        </Link>
      </div>
      <div className={`content ${isGrid && '-grid'}`}>{renderContent()}</div>
    </div>
  )
}
